import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { InitializationView } from "./initialization/InitializationView";
import { JoinClusterModal } from "./initialization/JoinClusterModal";
import { CreateClusterModal } from "./initialization/CreateClusterModal";
import { WorkerNodeView } from "./WorkerNodeView";
import { ClusterStatusView } from "./status/ClusterStatusView";
import { useApi } from "../../app/apiContext";
export function ClusterPage() {
    const { statusApi } = useApi();
    const [showJoinModal, setShowJoinModal] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const { data: nodeConfig } = statusApi.useGetNodeConfigQuery();
    const controlPlaneUrl = nodeConfig?.control_plane_url ?? null;
    const isControlPlane = nodeConfig?.features.control_plane === true;
    const isWorkerNode = controlPlaneUrl !== null && !isControlPlane;
    if (isWorkerNode) {
        return /*#__PURE__*/ _jsx(WorkerNodeView, {
            controlPlaneUrl: controlPlaneUrl
        });
    }
    if (!isControlPlane) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(InitializationView, {
                    onCreateCluster: ()=>setShowCreateModal(true),
                    onJoinCluster: ()=>setShowJoinModal(true)
                }),
                /*#__PURE__*/ _jsx(JoinClusterModal, {
                    isOpen: showJoinModal,
                    onClose: ()=>setShowJoinModal(false)
                }),
                /*#__PURE__*/ _jsx(CreateClusterModal, {
                    isOpen: showCreateModal,
                    onClose: ()=>setShowCreateModal(false),
                    controlPlaneUrl: window.location.hostname
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(ClusterStatusView, {});
}
